import type { Translations } from '../../../types'

const shopMediaLibraryMessages: Translations = {
  "shop.mediaLibrary.title": "Media Library",
  "shop.mediaLibrary.defaultDescription": "Clicca una o più immagini per aggiungerle alla gallery, poi chiudi.",
  "shop.mediaLibrary.actions.close": "Chiudi",
  "shop.mediaLibrary.actions.prev": "Indietro",
  "shop.mediaLibrary.actions.next": "Avanti",
}

export default shopMediaLibraryMessages
